import Vue from 'vue';
import Vuex from 'vuex';
import actions from "./actions"
import mutations from "./mutations"
import getters from "./getters"
import manyCompany from './modules/manyCompany'

Vue.use(Vuex);

const state = {
    // 中文语言包
    messageCn: {
        message: {}
    },
    // 英文语言包
    messageEn: {
        message: {}
    },
    // 跳转途径 to.path
    urlPath: '',
    // 跳转白名单
    whiteList: ['/grain', '/memberHome', '/memberVerify', '/preview_product', '/login', '/jumping', '/', '/selfRegister', '/casier_jump','/supplierCheckIn','/changePassword'],
    // 隐藏信息 默认不隐藏
    configAuth: {
        bothBottom: true, //网站底部是否显示
    },
    // 同项目多公司配置信息
    manyCompany: manyCompany
}

export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
})



// WEBPACK FOOTER //
// ./src/store/index.js